__turbopack_context__.v({
  "caption": "website-editorial-module__BPCIva__caption",
  "captionLabel": "website-editorial-module__BPCIva__captionLabel",
  "controls": "website-editorial-module__BPCIva__controls",
  "glass": "website-editorial-module__BPCIva__glass",
  "panel": "website-editorial-module__BPCIva__panel",
  "productFrame": "website-editorial-module__BPCIva__productFrame",
  "productHeader": "website-editorial-module__BPCIva__productHeader",
  "scene": "website-editorial-module__BPCIva__scene",
  "steps": "website-editorial-module__BPCIva__steps",
  "video": "website-editorial-module__BPCIva__video",
  "workflow": "website-editorial-module__BPCIva__workflow",
});
